import React from 'react'
import { Button, Col, Grid, Row } from 'rsuite';

export const Album = () => {

    return (
        <Grid  fluid>
            <Row>
                <Col xs={24} md={12} lg={6}>
                    <div className="card">
                        <img src="/assets/images/albumV2023.jpg" className="card-img-top" alt="..." />
                        <div className="card-body">
                            {/* <h5 className="card-title">BY THE BYE</h5> */}
                            <p className="card-text">Revive los mejores momentos de tu viaje y etiquétanos en nuestras redes para ganar termos gorras y trajes de baño !!! Y si regresas a donde fuiste feliz en el Verano 2024 hasta barras libres e increíbles descuentos !!  🥳💠</p>
                        </div>
                        <div className="card-footer" align="center">
                        <Grid fluid>
                            <Row gutter={16}>
                            <Col xs={12}>
                                <div className="show-col">
                                <Button
                                    // appearance="ghost"
                                    color="green"
                                    href="https://we.tl/t-mOLl1Xa5CS"
                                    target="_blank"
                                >
                                    Album 1
                                </Button>
                                </div>
                            </Col>
                            <Col xs={12}>
                                <div className="show-col">
                                    <Button
                                        // appearance="ghost"
                                        color="green"
                                        href="https://we.tl/t-k5ocpTSzU5"
                                        target="_blank"
                                    >
                                        Album 2
                                    </Button>
                                </div>
                            </Col>
                            </Row>
                        </Grid>
                        </div>
                    </div>
                </Col>
            </Row>

        </Grid>
    )
}
